import  Axios from "axios";
import {
    SET_COLOR_LIST,
    UNSET_COLOR_LIST,
  } from "@/store/mutation-types";
  import { getColorList , saveUpdateColor } from "@/store/api";

// initial state
const state = {
  getColorList: [],
};

const getters = {
  getColorList(state) {
    return state.getColorList;
  },
};

const mutations = {
  [SET_COLOR_LIST](state, data) {
    state.getColorList = data;
  },
  [UNSET_COLOR_LIST](state) {
    state.getColorList = [];
  },
};


const actions = {

  saveUpdateColor({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateColor, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getColorList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getColorList, data)
        .then(function (response) {
          commit('SET_COLOR_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_COLOR_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },
};


export default {
  state,
  getters,
  mutations,
  actions,
}